// src/App.js
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { miracleTheme } from './lib/theme';
import { AppRoutes } from './routes/AppRoutes';
import { FeedbackDialog } from './components/common/FeedbackDialog';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: 1 },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={miracleTheme}>
        <CssBaseline />
        <BrowserRouter>
          <AppRoutes />
          <FeedbackDialog />
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;